// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var ReactIO = require("./ReactIO.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");

function createErrorMessage(message, graphqlErrors, networkError, param) {
  return {
          message: message,
          graphqlErrors: graphqlErrors,
          networkError: networkError
        };
}

function parseError(param, param$1, param$2) {
  return {
          message: "Parse error",
          graphqlErrors: param,
          networkError: param$1
        };
}

function useGraphQLSubscription(onResult, createSubscription, authorizedClient) {
  return ReactIO.useIOOnMount((function (param) {
                return Relude_Result.fold(Relude_IO.pure, (function (param) {
                              return Relude_Globals.$great$great(Relude_IO.pure, (function (param) {
                                            return Relude_IO.map((function (prim) {
                                                          prim.unsubscribe();
                                                          
                                                        }), param);
                                          }), param);
                            }), param);
              }), (function (param) {
                return Relude_Result.fold(Relude_Globals.id, (function (prim) {
                              
                            }), param);
              }), Relude_IO.map(Curry._1(createSubscription, (function (param) {
                        return Relude_Result.fold((function (param) {
                                      return Relude_Globals.$great$great((function (prim) {
                                                    
                                                  }), Relude_IO.pure, param);
                                    }), onResult, param);
                      })), authorizedClient));
}

exports.createErrorMessage = createErrorMessage;
exports.parseError = parseError;
exports.useGraphQLSubscription = useGraphQLSubscription;
/* ReactIO Not a pure module */
